import { useEffect } from 'react';

import { AnalyticEvent } from ':fat/analytics/events';
import { logRender } from ':fat/analytics/logActions';
import { SecurityFrame } from ':fat/messaging/entities/securityFrame';
import { LoadingPage } from ':fat/pages/Loading';

// This page doesn't render anything, because while this route is active the
// security frame will be rendered on top of the whole page. It uses the same
// PageLayout component as this one does, so visually it won't look any
// different.
export function SecurityFrameLoaderPage() {
  useEffect(() => {
    logRender(AnalyticEvent.SecurityFrameLoaderPageRendered);
    // If the security frame is already loaded, this will tell it to go back to
    // the first page (which is also the default the first time it loads)
    SecurityFrame.actions.goToFirstPage();
  }, []);

  // Render a loader, which will be hidden once the frame loads on top of it
  return <LoadingPage />;
}
